import axiosInstance from "../instance/axiosInstance";

class BillingApi {
  static async getPlansList() {
    try {
      const response = await axiosInstance.get(`/get-plans`);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async requestGracePeriod() {
    try {
      const response = await axiosInstance.get(`/grace-period-request`);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async autoSubscribeStatus(status) {
    try {
      const response = await axiosInstance.get(`/auto-susbcription?status=${status}`);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async upgradeOrgPlan(formData) {
    try {
      const response = await axiosInstance.post(
        `/upgrade-organization-plan`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
}

export default BillingApi;
